import { Component, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { Platform } from 'ionic-angular';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { KeyboardProvider } from '../../providers/keyboard/keyboard';

/**
 * Generated class for the RmtInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-input',
  templateUrl: 'rmt-input.html'
})
export class RmtInputComponent {

  //#region input default behavior
  /**
   * default input section behavior
   * When the user taps on an enabled input:
   * The input name will be animated and will move to the top left corner of the input.
   * The user can type information inside the input.
   * when the user type the first character inside the input Display an X icon at the right of the input.
   * when the user taps on this X we icon Delete all the information inside the input and we hide the X icon until the user types again.
  */

  /**
   * inputField will be used in case we are using formControl to get and set values and validation of the <rmt-input> element.
  */
  @ViewChild('inputField') inputField;

  /**
   * inputField1 will be used in case we are using value to specifies the value of the <rmt-input> element.
  */
  @ViewChild('inputField1') inputField1;
  @ViewChild('container', { read: ElementRef }) container;

  /**
    * assign an identifier to the  <rmt-input> element.
    * @defaultValue
    * The default is empty string unless
    *  `inputId` was requested.
    * @example
    * Here's an example with `inputId` that can be used for login :
    * inputId="loginId".
   */
  @Input() inputId: string = "";

  /**
   * used to track values and validation of a form control(input content).
   * @example
   * Here's an example with hoe we set the formControl  :
   * <form [formGroup]="formGroup">
   * <rmt-input  [formControl]="formGroup.controls.example"/>
   * </form>
  */
  @Input() formControl;

  /**
   * The input Label
  */
  @Input() title;

  /**
   * The input type
   * @example
   * Here's an example with inputType that can be used  :
   * inputType="password
   * inputType="text"
  */
  @Input() inputType;

  /**
   * The `isInputDisabled` attribute is a boolean attribute. When present, it specifies that the <rmt-input> element should be disabled hint or not
   * @defaultValue
   * The default is `false` unless
   *  `isInputDisabled` was requested.
  */
  @Input() isInputDisabled: boolean = false;

  /**
   * The `isActive` attribute is a boolean attribute. When present, it specifies that the <rmt-input> element should be in Active status  or not
   * This attribute is used as workaround in some cases when the input value is set but when we check the input.value = null ;
   * @defaultValue
   * The default is `false` unless
   *  `isActive` was requested.
  */
  @Input() isActive: boolean = false;
  @Input() isDateField: boolean = false;

  /**
   * specifies the value of the <rmt-input>
   * in ngAfterViewInit() we are checking if the `inputText` have a value, in this case  will be using   else inputField ;
   * @example
   * we have one example in the app that used the `inputText ` is in settings-personal.ts
   *   <rmt-input  [inputText]="object.example"/>
  */
  @Input() inputText = null;
  @Input() inputMinVal;
  @Input() inputMaxVal;
  @Input() inputMaxlength;

  @Input() hideHintIcon = false;

  @Output() focusEmitter = new EventEmitter<any>();
  @Output() blurEmitter = new EventEmitter<any>();
  @Output() blurNoDelayEmitter = new EventEmitter<any>();
  @Output() mousedownEmitter = new EventEmitter<any>();

  @Output() inputEmitter = new EventEmitter<any>();
  @Output() keydownEmitter = new EventEmitter<any>();
  @Output() keyupEmitter = new EventEmitter<any>();
  @Input() searchItemClick;
  @Input() isSearchInput: boolean = false;
  @Input() searchArray = [];
  @Input() searchReady: boolean = false;
  @Input() showSearchLoader: boolean = false;
  /**
  * @defaultValue
  * The default is `off` is not permitted to automatically enter a value for this field unless
  *  `autocompleteName` was requested.
  */
  @Input() autocompleteName: string = 'off';

  /**
   * Used to update controllers validation
  */
  @Output() updateControllers: EventEmitter<any> = new EventEmitter();

  /**
  * The `isDynamicField` attribute is a boolean attribute. When present, it specifies that the <rmt-input> element id a dynamic field or not
  * in case isDynamicField = true we hide the rmt-error since we are usinf the one from rmt-dynamic-form
   * @defaultValue
   * The default value  is `false` unless
   *  `isDynamicField` was requested.
  */
  @Input() isDynamicField: boolean = false;

  /**
    * Used in case we display info action
   */
  @Input() dynamicField;

  /**
   * Used in case we display warning
  */
  @Input() showWarning: boolean = false;

  /**
   * Used in case we display info
  */
  @Input() showInfo: boolean = false;

  /**
   * Used in a specific  when we are updateing the email
  */
  @Input() isEmailSetting: boolean = false;
  //#endregion input default behavior
  //#region error
  /**
   * error section
   * information provided by the user that is not accepted. This includes:
   * information that is required by the  page but omitted by the user .
   * information that is provided by the user but that falls outside the required data format or allowed values
  */

  /**
   * The error message
  */
  @Input() errorMessage;

  @Input() defaultErrors: boolean = false;

  /**
   *Tracks the value and validation status of the error
  */
  @Input() refFormControlError;

  /**
  * The  `isErrorHidden` attribute is a boolean attribute. When present, it specifies that the <rmt-input> element should diplay error or not
  * @defaultValue
  * The default is `false` unless
  *  `isErrorHidden` was requested.
  */
  @Input() hideError: boolean = false;
  //#endregion error

  @Input() showForcedError = null;
  //#region hint
  /**
   * Hint section
   * help users establish what information should be entered into an input field .
  */

  /**
   * The showHint attribute is a boolean attribute. When present, it specifies that the <rmt-input> element should diplay hint or not
   * @defaultValue
   * The default is `false` unless
   *  `showHint` was requested.
   */
  @Input() showHint: boolean = false;

  /**
  * assign Id to hint
  * @example
  * Here's an example with hintId that can be used for password :
  * hintId="criteriaPasswordHint
  * hintId="strongPasswordHint"
  */
  @Input() hintId;

  /**
   * The error message
  */
  @Input() hintMessage?;
  //#endregion hint

  //#region input password/login behavior
  /**
  * input password/login behavior
  * we moved the logic of 'rmt-login' and 'rmt-password' inside the new component 'rmt-input'
  * to specify the type of the input by setting
  * The user can type information inside the input.
  * when the user type the first character inside the input Display an X icon at the right of the input.
  * when the user taps on this X we icon Delete all the information inside the input and we hide the X icon until the user types again.
 */

  /**
   * The `hasBiometrics` attribute is a boolean attribute. When present, it specifies that the <rmt-input> element should  disable Biometrics or not.
   * this attribute will be used just in case of login.
   * @defaultValue
   * The default is `false` unless
   *  `hasBiometrics` was requested.
  */
  @Input() hasBiometrics: boolean = false;

  /**
   * The `passwordHint` attribute is a boolean attribute. When present, it specifies that the <rmt-input> element should disable hint for password or not.
   * this attribute will be used just in case of password.
   * @defaultValue
   * The default is `false` unless
   *  `passwordHint` was requested.
  */
  @Input() passwordHint: boolean = false;

  /**
   * The `passwordHintDisclaimer` attribute is a string attribute. When present, it displays an additional disclaimer message below the password hint.
   * @example
   * passwordHintDisclaimer="Password must not include personal data such as your name, date of birth, or NRIC number."
  */
  @Input() passwordHintDisclaimer: string = '';

  /**
   * The `isPassword` attribute is a boolean attribute. When present, it specifies that the <rmt-input> element should be displayed as rmt-password or not.
   * this attribute will be used to change the bahvior of the `rmt-input` to rmt-password.
   * @defaultValue
   * The default is `false` unless
   *  `isPassword` was requested.
  */
  @Input() isPassword: Boolean = false;

  /**
   * The `isLogin` attribute is a boolean attribute. When present, it specifies that the <rmt-input> element should be displayed  as rmt-login or not.
   * this attribute will be used to change the bahvior of the `rmt-input` to rmt-login.
   * @defaultValue
   * The default is `false` unless
   * `isLogin` was requested.
  */
  @Input() isLogin: Boolean = false;

  /**
   * The `showPassword` attribute is a boolean attribute. When present, it specifies if we hide or display the content(the password).
   * @defaultValue
   * The default is `false` unless
   * `showPassword` was requested.
  */
  @Input() showPassword: boolean = false;

  @Input() isPhone: boolean = false;

  @ViewChild('passwordcriteria', { read: ElementRef }) passwordcriteria;
  @Input() keepPasswordHint: boolean = false;


  @Output() biometrics = new EventEmitter<any>();

  /**
  * The `biometricsEnabled`,  `isFaceIdEnabled` and `pendingBiometrics` attribute is a boolean attribute. When present, it specifies that the <rmt-input> element should enable biometrics , faceId  or not.
  * this attribute will be used to change the bahvior of the `rmt-input` to rmt-login.
  * @defaultValue
  * The default is `false` unless
  * `isLogin` was requested.
 */
  @Input() biometricsEnabled: boolean = false;
  @Input() isFaceIdEnabled: boolean = false;
  @Input() pendingBiometrics: boolean = false;
  @Input() isCvv: boolean = false;

  @Input() isCvvInfo: boolean = false;
  @Input() isCardOCR: boolean = false;
  @Input() onClearCb;
  //#endregion input password/login behavior

  @Input() forcedFocus: boolean = false;
  @Input() customIconLeft: string;
  @Input() customIcon: string;
  @Input() customPrefixLeft: string;
  @Output() customIconClick = new EventEmitter<any>();

  /**
   * The `patternForMask` attribute is a string attribute. When present, it specifies that the <rmt-input> element should have a mask of given pattern.
   */
  @Input() patternForMask: string;

  /** OM-18281: imask pattern for visual-only formatting. Routed to the input via [rmtVisualMask]. Form control gets the unmasked value. */
  @Input() visualMask: string;

  /** OM-18281: paste preprocessor — runs on raw clipboard text before the mask sees it. */
  @Input() visualMaskPrepare: (raw: string) => string;
  //#region
  floatContainer: any;
  //clear button behavior
  isClearHidden: boolean = true;
  //valid button behavior
  isValideHidden: boolean = true;
  floatContainers;
  inputElemt;
  //default value when we click on clear input
  inputDefaultValue = '';
  cardCvv: string = 'assets/img/payment-card/cardPayment.svg';
  isErrorHidden: boolean = true;
  hideClearTimeout;
  handleBlurTimeout;
  inputTarget;
  floatLabel;
  showErrorOnTouch: Boolean = false;

  debounceTimeout;
  passwordSuccess: boolean = false;
  //#endregion
  constructor(private platform: Platform, private keyboard: KeyboardProvider) {
  }

  ngAfterViewInit() {
        try {
      // check if the `inputText` have a value, in this case  will be using inputField1 else inputField
      this.inputElemt = this.inputField1 || this.inputField;
      if (this.isCvv) {
        if (this.inputElemt) {
          this.inputElemt.nativeElement.maxlength = this.inputMaxlength;
        }
      }
      if (this.isInputDisabled) {
        if (this.inputElemt) {
          // if isInputDisabled = true disable rmt-input
          this.inputElemt.nativeElement.disabled = true;
        }
      }
      if (this.isActive || (this.inputElemt && this.inputElemt.nativeElement.value)) {
        this.addActiveClass(this.inputElemt.nativeElement)
      }
      if(this.isCvvInfo){
        this.cardCvv = 'assets/icons/info.svg';
      }

    }
    catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.GeneralException, 'Failed to initialize input');
    }
  }

  addActiveClass(target) {
    target.parentNode.classList.add('active');
    target.parentNode.classList.add('active-focus');
    if (target.getAttribute('data-placeholder'))
      target.setAttribute('placeholder', target.getAttribute('data-placeholder'));
  }

  onValueChange(ev) {
    var isFocused = (document.activeElement === this.inputElemt.nativeElement) ? true : false;
    if (this.inputElemt && this.inputElemt.nativeElement) {
      const classList = this.inputElemt.nativeElement.parentNode && this.inputElemt.nativeElement.parentNode.classList;
      if (ev && !classList.contains('active')) {
        classList.add('active');
      } else if (!ev && ev != " " && !classList.contains('active-focus') && !this.isActive) {
        classList.remove('active');
      } else if (!ev && ev != " " && !isFocused && !this.isActive) {
        classList.remove('active');
        classList.remove('active-focus');
      }
    }
    if (this.refFormControlError && this.refFormControlError.touched) {
      this.updateFormValidity();
    }
  }

  ngOnDestroy() {
   this.clearTimeout();
  }

  ngOnChanges() {
    if (this.inputElemt && this.inputElemt.nativeElement) {
      const classList = this.inputElemt.nativeElement.parentNode && this.inputElemt.nativeElement.parentNode.classList;
      if (this.isActive && classList && !classList.contains('active')) {
        classList.add('active');
        if (this.refFormControlError) {
          this.updateFormValidity();
        }
      } else if (!this.isActive && !classList.contains('active-focus') && !this.inputElemt.nativeElement.value) {
        classList.remove('active');
      }

      if (this.isInputDisabled) {
          // if isInputDisabled = true disable rmt-input
          this.inputElemt.nativeElement.disabled = true;
      } else {
        this.inputElemt.nativeElement.disabled = false;
      }
    }

    if (this.showForcedError === true) {
      this.isErrorHidden = false;
    } else if (this.showForcedError === false) {
      this.isErrorHidden = true;
    }
  }

  updateFormValidity() {
    if(this.refFormControlError !== null && this.refFormControlError !== undefined){
      // Don't reveal the error for a hideErrorWhileTyping field that the user hasn't blurred yet:
      // this path (via ngOnChanges/onValueChange) would otherwise mark it touched and surface
      // the error mid-typing. Once blurred (touched), it behaves normally.
      const hideWhileUntouched = this.dynamicField && this.dynamicField.hideErrorWhileTyping && !this.refFormControlError.touched;
      if (!hideWhileUntouched)
        this.refFormControlError.markAsTouched();
      this.refFormControlError.markAsDirty();
      this.refFormControlError.updateValueAndValidity();
      this.isErrorHidden = hideWhileUntouched ? true : (this.refFormControlError.errors ? false : true);
    }
  }

  //#region handel input behavior 

  public onKeyUp(ev) {
    if (this.keyupEmitter) {
      if (this.debounceTimeout) {
        window.clearTimeout(this.debounceTimeout)
      }

      this.debounceTimeout = window.setTimeout(() => {
        this.keyupEmitter.emit(ev);
      }, 1000);
    }
  }

  // check if the user modifies the input value
  public inputValueChanged(ev) {
    this.isErrorHidden = true;
    const value = ev.target.value;

    if (value && value != " ") {
      this.isClearHidden = false;
    }
    else {
      this.isClearHidden = true;
      ev.target.value = this.inputDefaultValue;
    }
    if (this.hideError)
      this.isErrorHidden = true;
    // Marking the control touched per keystroke is what surfaces the inline error as-you-type.
    // hideErrorWhileTyping fields invert this: reset touched on each keystroke so a previously-shown
    // error re-hides while typing and only reappears on blur. Display-only — submit gates on validity.
    else if (this.dynamicField && this.dynamicField.hideErrorWhileTyping)
      this.formControl && this.formControl.markAsUntouched();
    else
      this.formControl && this.formControl.markAsTouched();

    this.inputEmitter.emit(ev.target);

    if (this.showForcedError === true) {
      this.isErrorHidden = false;
    }
  }

  // display clear button when the input has value ans is on focus
  public inputOnFocus(ev) {
    let target = ev.target;
    this.keyboard.keyboardType = this.inputType;
    this.addActiveClass(target);

    this.showErrorOnTouch = this.isPassword && this.passwordHint

    this.focusEmitter.emit(ev.target);
    if (ev.target.value && ev.value != " ") {
      this.isClearHidden = false;
    } else {
      ev.target.value = this.inputDefaultValue;
      this.isClearHidden = true;
    }
  }

  public keydownInput(ev) {
    if (this.keydownEmitter) {
      this.keydownEmitter.emit(ev);
    }
  }

  public clearTimeout() {

    if (this.handleBlurTimeout) {
      window.clearTimeout(this.handleBlurTimeout)
    }

    if (this.hideClearTimeout) {
      window.clearTimeout(this.hideClearTimeout)
    }
  }

  // check  refFormControlError validation
  public inputOnBlur(ev) {
    this.blurNoDelayEmitter.emit(ev.target);
    this.clearTimeout();
    this.handleBlurTimeout = window.setTimeout(() => {
      const target = ev.target;
      if ((!target.value || target.value == " ") && !this.isActive) {
        target.parentNode.classList.remove('active');
        target.parentNode.classList.remove('active-focus');
      }
      target.removeAttribute('placeholder');

      this.blurEmitter.emit(ev.target);
      if (this.refFormControlError) {
        this.refFormControlError.touched = true
      }
      this.onBlurErrorToggle(ev);
      this.hideClearTimeout = window.setTimeout(() => {
        this.isClearHidden = true;
      }, 75);

    }, 100);
  }

  onBlurErrorToggle(ev) {
    if (this.hideError) {
      this.isErrorHidden = true;
    } else if (!this.refFormControlError && ev.target.value && ev.value != " ") {
      this.isErrorHidden = true;
    } else if (ev.target.value && this.refFormControlError && this.refFormControlError.valid) {
      this.isErrorHidden = true;
    } else {
      this.isErrorHidden = false;
    }

    if (this.showForcedError === false) {
      this.isErrorHidden = true;
    } else if(this.showForcedError === true) {
      this.isErrorHidden = false;
    }
  }

  // set input value to inputDefaultValur id clear button is clicked and update form validation
  clear(ev) {
    this.isClearHidden = true;
    if (this.inputElemt) {
      this.inputElemt.nativeElement.value = this.inputDefaultValue;
      if (this.formControl) {
        this.formControl.setValue(this.inputDefaultValue);
      }
    }
    ev.stopPropagation();
    if (this.refFormControlError && !this.hideError) {
      this.refFormControlError.setErrors({'incorrect': true});
    } else{
      this.updateFormValidity();
    }
    if (this.onClearCb) {
      this.onClearCb()
    }
  }

  // display info action when info button is clicked
  action() {
    this.mousedownEmitter.emit();
    if (this.dynamicField && this.dynamicField.infoAction)
      this.dynamicField.infoAction();
  }

  // get input type
  public getInputType() {
    if (this.isPassword || this.isCvv) {
      if (this.showPassword) {
        this.inputType = 'text';
        return 'text';
      }
      this.inputType = 'password';
      return 'password';
    } else if (this.inputType === 'number') {
      this.inputType = 'number';
      return 'number';
    } else if (this.inputType === 'tel') {
      this.inputType = 'tel';
      return 'tel';
    } else if (this.inputType === 'numberCustom') {
      return 'number';
    } else if (this.inputType === 'numeric') {
      return 'numeric';
    }
    this.inputType = 'text';
    return 'text';
  }

  inputLength(){
    let length = 0;

    try {
      if (this.inputElemt && this.inputElemt.nativeElement && this.inputElemt.nativeElement.value) {
        length = this.inputElemt.nativeElement.value.length;
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.GeneralException, 'Failed to get input length');
    }

    return length;
  }

  public getInputMode(): string {
    if (this.isCvv) {
      // Ensures a numeric keyboard is displayed while text is hidden
      return 'numeric';
    } else {
      return this.getInputType();
    }
  }


  //#endregion input behavior

  //#region functions for Password, input behavior as rmt-password
  // hide and show password based on user action
  public togglePassword(ev) {
     // Prevent keyboard from dismissing on toggle
    if (ev && ev.preventDefault) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    this.showPassword = !this.showPassword;
  }

  // check if input content lengh for password
  passwordCriteriaLength() {
    let result = false;
    if (!this.inputElemt) return;
    if (this.inputElemt.nativeElement && this.inputElemt.nativeElement.value && this.inputElemt.nativeElement.value.length >= 8)
      result = true;
    return this.passwordValid(result);
  }

  // check if  input content contain criterial letter for password
  passwordCriteriaLetter() {
    let result = false;
    if (this.inputElemt && this.inputElemt.nativeElement && this.inputElemt.nativeElement.value) {
      const reg = /^(?=.*[A-Z]).{1,}$/;
      if (reg.test(this.inputElemt.nativeElement.value))
        result = true;
    }
    return this.passwordValid(result);
  }

  // check if input content contain criterial lower case letter for password
  passwordCriteriaLowerCaseLetter() {
    let result = false;
    if (this.inputElemt && this.inputElemt.nativeElement && this.inputElemt.nativeElement.value) {
      const reg = /^(?=.*[a-z]).{1,}$/;
      if (reg.test(this.inputElemt.nativeElement.value))
        result = true;
    }
    return this.passwordValid(result);
  }

  // check if  input content contain criterial number for password
  passwordCriteriaNumber() {
    let result = false;
    if (this.inputElemt && this.inputElemt.nativeElement && this.inputElemt.nativeElement.value) {
      const reg = /^(?=.*[0-9]).{1,}$/;
      if (reg.test(this.inputElemt.nativeElement.value))
        result = true;
    }
    return this.passwordValid(result);
  }

  passwordValid(result){
    if (this.inputElemt && this.inputElemt.nativeElement && this.inputElemt.nativeElement.value.length == 0){
      return false;
    }
    return result;
  }
  //#endregion input behavior as rmt-password

  //#region input behavior as rmt-login

  //check if biometrics is enabled or not
  getBiometricsIconVisibility() {
    return this.biometricsEnabled ? 'visible' : 'hidden';
  }

  //check type of  biometrics
  getBiometricsIconName() {
    return this.isFaceIdEnabled ? 'custom-icon-faceid' : 'custom-icon-touchId'
  }


  finishBiometrics() {
    window.setTimeout(() => {
      if (!this.pendingBiometrics)
        this.isErrorHidden = false;
    }, 500);
  }


  startBiometrics() {
    this.pendingBiometrics = true;
    this.isErrorHidden = true;
    // callback when biometrics is finished
    this.biometrics.emit((result) => {
      this.pendingBiometrics = false;
      if (!result)
        this.isErrorHidden = false;
    });
  }

  touchBiometrics() {
    this.isErrorHidden = true;
  }

  getCustomInputClass() {
    let customClass = '';
    if (this.platform.is('ios') && this.isInputDisabled) {
      customClass = 'input-ios-disabled';
    }
    return customClass;
  }

  selectItem(city) {
    if(this.searchItemClick) {
      this.searchItemClick(city);
    }
  }
  getItemText(item) {
    if(item.cityName)
      return `${item.cityName}, ${item.state}`;

    return item.name;
  }
  //#endregion input behavior as rmt-login

  getNativeElement() {
    if (this.inputElemt && this.inputElemt.nativeElement)
      return this.inputElemt.nativeElement.value;
    return null;
  }

  setValue(value) {
    if (this.inputElemt && this.inputElemt.nativeElement) {
      this.inputElemt.nativeElement.value = value;
      if (value)
        this.addActiveClass(this.inputElemt.nativeElement);
    }
  }

  checkForPattern() {
    if (this.patternForMask) {
      return this.patternForMask;
    }
    return '';
  }

  clickCustomIcon() {
    this.customIconClick.emit();
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-input/rmt-input.ts